import React from 'react';

const DashboardIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.848 16.4973C16.0208 16.4968 16.1863 16.4279 16.3085 16.3058C16.4306 16.1836 16.4995 16.0181 16.5 15.8453V7.49731C16.4885 7.29369 16.3984 7.1025 16.2487 6.96398L9 1.49731L1.75133 6.96398C1.60164 7.1025 1.51154 7.29369 1.5 7.49731V15.8453C1.50053 16.0181 1.56939 16.1836 1.69155 16.3058C1.81371 16.4279 1.97924 16.4968 2.152 16.4973H15.848Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DashboardIcon;
